import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { medications } from "../data/medicationData";
import { procedures } from "../data/procedureData";
import { therapies } from "../data/therapyData";
import { nonInvasiveDevices } from "../data/nonInvasiveDevicesData";
import { nutrition } from "../data/nutritiondata";
import { alternativetreatment } from "../data/alternativeData";
import { imaging } from "../data/imagingData";
import { sleep } from "../data/sleepData";
import { braintraining } from "../data/brainData";

const SearchBar = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setQuery(searchTerm);

    if (searchTerm.length > 1) {
      const allData = {
        ...medications,
        ...procedures,
        ...therapies,
        ...nonInvasiveDevices,
        ...nutrition,
        ...alternativetreatment,
        ...imaging,
        ...sleep,
        ...braintraining,
      };

      const filteredResults = Object.keys(allData)
        .map((key) => ({
          ...allData[key],
          key,
          category: medications[key]
            ? "medications"
            : procedures[key]
            ? "medical-procedures"
            : therapies[key]
            ? "therapies"
            : nonInvasiveDevices[key]
            ? "non-invasive-devices"
            : nutrition[key]
            ? "nutrition"
            : alternativetreatment[key]
            ? "alternative-treatments"
            : imaging[key]
            ? "imaging"
            : sleep[key]
            ? "sleep"
            : braintraining[key]
            ? "braintraining"
            : "",
        }))
        .filter(
          (item) =>
            item.name?.toLowerCase().includes(searchTerm) ||
            item.description?.toLowerCase().includes(searchTerm) ||
            (item.conditions &&
              item.conditions.some((c) =>
                c.toLowerCase().includes(searchTerm)
              ))
        );

      setResults(filteredResults);
    } else {
      setResults([]);
    }
  };

  const handleResultClick = (item) => {
    navigate(`/${item.category}?treatment=${item.key}`);
  };

  return (
    <div className="search-container">
      <input
        type="text"
        placeholder="Search treatments or conditions..."
        value={query}
        onChange={handleSearch}
        className="search-input"
      />

      {results.length > 0 && (
        <div className="search-results">
          {results.map((result, index) => (
            <div
              key={index}
              className="search-result-card"
              onClick={() => handleResultClick(result)}
            >
              <h3>{result.name} →</h3>
              <p>{result.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
